import React, { Component } from 'react'
import Swiper from 'react-id-swiper'
import styles from './index.module.less'
import Utils from '../../lib/utils'
import './swiper.less'
export default class FocusSwiper extends Component {
  static defaultProps = {
    data: {}
  }
  constructor (props) {
    super(props)
    this.state = {
      gallerySwiper: null,
      thumbnailSwiper: null,
      isHideNav: true,
      bottom: 0
    }
    this.data = props.data
    this.galleryRef = this.galleryRef.bind(this)
    this.thumbRef = this.thumbRef.bind(this)
    this.itemClickFn = this.itemClick.bind(this)
  }

  // componentWillUpdate
  componentWillUpdate (nextProps, nextState) {
    if (nextState.gallerySwiper && nextState.thumbnailSwiper) {
      const { gallerySwiper, thumbnailSwiper } = nextState
      gallerySwiper.controller.control = thumbnailSwiper
      thumbnailSwiper.controller.control = gallerySwiper
    }
  }

  componentDidMount () {
    if (this.data.bottom) {
      this.setState({ isHideNav: false, bottom: this.data.bottom })
    } else {
      this.setState({ isHideNav: false })
    }
  }

  galleryRef (ref) {
    if (ref) this.setState({ gallerySwiper: ref.swiper })
  }

  thumbRef (ref) {
    if (ref) this.setState({ thumbnailSwiper: ref.swiper })
  }

  // 实现hover鼠标切换事件
  handleMouseEnter (index) {
    if (index !== this.state.thumbnailSwiper.activeIndex) {
      this.state.thumbnailSwiper.slideTo(index)
    }
  }

  itemClick (args) {
    const el = args.currentTarget
    Utils.sendClickLog(el)
  }

  render () {
    if (!this.props.data || this.props.data.length < 1) {
      return ''
    }
    const gallerySwiperParams = {
      spaceBetween: 30,
      effect: 'fade',
      // loop: true,
      // pagination: {
      //   el: '.swiper-pagination',
      //   clickable: true
      // },
      autoplayDisableOnInteraction: false,
      autoplay: {
        delay: 5000,
        // stopOnLastSlide: false,
        loop: true,
        autoplayDisableOnInteraction: false
        // disableOnInteraction: true
      }
    }
    const thumbnailSwiperParams = {
      direction: 'vertical',
      paceBetween: 10,
      centeredSlides: true,
      slidesPerView: 'auto',
      touchRatio: 0.2,
      slideToClickedSlide: true
    }

    const _navClassName = this.state.isHideNav ? `focus_nav ${styles.focus_nav} ${styles.focus_nav_hide}` : `focus_nav ${styles.focus_nav}`
    const style = this.state.bottom ? { marginBottom: `${this.state.bottom}px` } : {}
    const trackInfo = this.data.trackInfo
    return (
      <div className={styles.focus_wrap}
        style={style}
        data-spm={this.data.spm}
        data-name='c_pos'
        data-mname={trackInfo.drawer}
        data-cname={trackInfo.component_title}
        data-cid={trackInfo.component_id}
        data-mid={trackInfo.drawerid}
        data-trackinfo={JSON.stringify(trackInfo)}>
        <Swiper {...gallerySwiperParams} ref={this.galleryRef}>
          {
            this.data.focusList.map((item, index) => (

              <div key={index}>
                <div className={styles.focus_item} style={{
                  backgroundImage: `url(${item.img})`,
                  backgroundColor: `${item.color || '#262626'}`
                }}>
                  <a data-spm={item.spm}
                    data-scm={item.scm}
                    data-trackinfo={item.trackInfo ? JSON.stringify(item.trackInfo) : '{}'}
                    target='_blank'
                    href={`${item.link}?spm=${item.spm}`}
                    className={styles.focus_cover}
                    style={{
                      backgroundImage: `url(${item.background || '//gw.alicdn.com/mt/TB1Sw8Tom_I8KJjy0FoXXaFnVXa-1664-520.png'})`
                    }}
                    title={item.title}
                    onClick={this.itemClickFn} />
                </div>
              </div>

            ))
          }
        </Swiper>
        <div className={_navClassName}>
          <Swiper {...thumbnailSwiperParams} ref={this.thumbRef}>
            {
              this.props.data.focusList.map((item, index) => (
                <a data-spm={item.spm}
                  data-scm={item.scm}
                  data-trackinfo={item.trackInfo ? JSON.stringify(item.trackInfo) : '{}'}
                  target='_blank'
                  href={`${item.link}?spm=${item.spm}`}
                  key={index}
                  onClick={this.itemClickFn} >
                  <div className={styles.nav_slide}
                    onMouseEnter={this.handleMouseEnter.bind(this, index)}>
                    <h2> <span className={`nav_index nav_index_${index + 1}`}>{index + 1}</span>{item.title}</h2>
                    {/* <span className='title_split'>:</span> */}
                    <div className={`sub_title ${styles.sub_title}`}>{item.subtitle}</div>
                  </div>
                </a>
              ))
            }
          </Swiper>
        </div>
      </div>
    )
  }
}
